import { useOnMount } from '@seiue/util'
import { FC, useContext, useState } from 'react'
import { Document, Page, pdfjs } from 'react-pdf'
import styled from 'styled-components'

import { TaskCompletedDetail } from 'packages/sdks-next/growp'
// import 'react-pdf/dist/esm/Page/TextLayer.css'
// import 'react-pdf/dist/esm/Page/AnnotationLayer.css'

import { CourseContext } from '../../context'
import { useUpdateOutlineComplete } from '../../utils'
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

/**
 * pdf 内容
 *
 * @param param0 - 参数
 * @param param0.url - pdf url
 * @param param0.curCompletedDetail - 当前完成详情
 * @returns pdf 内容
 */
export const PdfContent: FC<{
  url: string
  curCompletedDetail: TaskCompletedDetail | undefined
}> = ({ url, curCompletedDetail }) => {
  const { currentOutline, isPreview } = useContext(CourseContext)
  const [allPages, setAllPages] = useState<number>(1)
  const [pdfWidth, setPdfWidth] = useState<number>(0)
  const getAllPages = (pageNums: number) => {
    setAllPages(pageNums)
  }

  const updateOutlineComplete = useUpdateOutlineComplete()

  window?.addEventListener('resize', () => {
    // 当窗口大小改变时，重新计算 pdf 宽度
    const cardEle = document.getElementsByClassName('user_course_left_card')
    if (cardEle?.[0]) {
      setPdfWidth(
        cardEle?.[0]?.clientWidth ? cardEle?.[0]?.clientWidth - 48 : 0
      )
    }
  })

  useOnMount(() => {
    const cardEle = document.getElementsByClassName('user_course_left_card')
    if (cardEle?.[0]) {
      setPdfWidth(
        cardEle?.[0]?.clientWidth ? cardEle?.[0]?.clientWidth - 48 : 0
      )
    }
  })

  return (
    <Content $isPreview={isPreview}>
      <Document
        file={url}
        onLoadSuccess={async (val) => {
          getAllPages(val.numPages)
          if (
            !isPreview &&
            !curCompletedDetail?.isCompleted &&
            currentOutline?.id
          ) {
            await updateOutlineComplete({
              taskId: currentOutline?.id,
              id: currentOutline.parentId || 0,
              payload: { isCompleted: true },
            })
          }
        }}
      >
        {new Array(allPages).fill('').map((cur, index) => (
          <div key={index}>
            <Page
              width={pdfWidth}
              pageNumber={index + 1}
            />
          </div>
        ))}
      </Document>
    </Content>
  )
}
const Content = styled.div<{ $isPreview: boolean }>`
  max-height: calc(100vh - ${(props) => (props.$isPreview ? 254 : 204)}px);
  .pdf_page {
    width: 100%;
  }
`
